import { DocumentNode, gql } from '@apollo/client'

export const CREATE_CLOSING_DAY: DocumentNode = gql`
    mutation createClosingDay(
        $daycare_id: Int!
        $start_date: Date!
        $end_date: Date!
        $closing_day_reason: String!
        $closing_day_message: String!
    ) {
        createClosingDay(
            daycare_id: $daycare_id
            start_date: $start_date
            end_date: $end_date
            closing_day_reason: $closing_day_reason
            closing_day_message: $closing_day_message
        )
    }
`

export const UPDATE_CLOSING_DAY: DocumentNode = gql`
    mutation updateClosingDay(
        $closing_day_id: Int!
        $start_date: Date
        $end_date: Date
        $closing_day_reason: String
        $closing_day_message: String
        $daycare_id: Int!
    ) {
        updateClosingDay(
            closing_day_id: $closing_day_id
            start_date: $start_date
            end_date: $end_date
            closing_day_reason: $closing_day_reason
            closing_day_message: $closing_day_message
            daycare_id: $daycare_id
        )
    }
`

export const GET_CLOSING_DAY: DocumentNode = gql`
    query getClosingDay($daycare_id: Int!, $from: Date, $to: Date) {
        getClosingDay(daycare_id: $daycare_id, from: $from, to: $to) {
            id
            daycareId
            startDate
            endDate
            closingDaysReason
            closingDaysMessage
        }
    }
`

export const DELETE_CLOSING_DAY: DocumentNode = gql`
    mutation deleteClosingDay($closing_day_id: Int!, $daycare_id: Int!) {
        deleteClosingDay(closing_day_id: $closing_day_id, daycare_id: $daycare_id)
    }
`

export const DUPLICATE_CLOSING_DAY: DocumentNode = gql`
    mutation duplicateClosingDay($closingDayId: Int!, $daycareId: Int!, $dateList: [Date]!) {
        duplicateClosingDay(closingDayId: $closingDayId, daycareId: $daycareId, dateList: $dateList)
    }
`
